module.exports = __webpack_public_path__ + "static/media/mm.405fb8d1.webp";